import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Clock } from 'lucide-react';
import { clinicInfo } from '../data/mockData';

const Footer = () => {
  return (
    <footer className="bg-primary text-white mt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="col-span-1">
            <h3 className="text-2xl font-bold mb-3">Mind Motion</h3>
            <p className="text-sm text-gray-100 mb-4">
              Personalised physiotherapy. Evidence-led. Local to Bellandur.
            </p>
            <p className="text-xs text-gray-200">
              Pain → Recovery → Movement
            </p>
          </div>

          {/* Quick Links */}
          <div className="col-span-1">
            <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-gray-100 hover:text-white transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/treatments" className="text-sm text-gray-100 hover:text-white transition-colors">
                  Treatment
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-gray-100 hover:text-white transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/locations" className="text-sm text-gray-100 hover:text-white transition-colors">
                  Locations
                </Link>
              </li>
              <li>
                <Link to="/resources" className="text-sm text-gray-100 hover:text-white transition-colors">
                  Helpful Resources
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="col-span-1">
            <h4 className="text-lg font-semibold mb-4">Contact</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-2">
                <Phone className="w-4 h-4 mt-1 flex-shrink-0" />
                <a href={`tel:${clinicInfo.phone}`} className="text-sm text-gray-100 hover:text-white transition-colors">
                  {clinicInfo.phone}
                </a>
              </li>
              <li className="flex items-start gap-2">
                <Mail className="w-4 h-4 mt-1 flex-shrink-0" />
                <a href={`mailto:${clinicInfo.email}`} className="text-sm text-gray-100 hover:text-white transition-colors">
                  {clinicInfo.email}
                </a>
              </li>
              <li className="flex items-start gap-2">
                <Clock className="w-4 h-4 mt-1 flex-shrink-0" />
                <span className="text-sm text-gray-100">Mon-Sat: 9:00 AM - 8:30 PM, Sun: 10:30 AM - 2:00 PM</span>
              </li>
            </ul>
          </div>

          {/* Locations */}
          <div className="col-span-1">
            <h4 className="text-lg font-semibold mb-4">Our Clinics</h4>
            <div className="space-y-4">
              <div>
                <p className="text-sm font-medium text-white mb-1">Bellandur</p>
                <p className="text-xs text-gray-100">opposite to vyapar exit gate, 10/2a, Bellandur gate, Sarjapur road</p>
                <p className="text-xs text-gray-200 mt-1">Bellandur, Bangalore - 560103</p>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/20 mt-8 pt-6 text-center">
          <p className="text-sm text-gray-100">
            © {new Date().getFullYear()} Mind Motion Physiotherapy and Rehab Centre. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
